<template>
  <div class="containar">
    <div class="clock-contents-block">
      <div class="">
        <div id="prebarclock" class="clock-preview barfont" :class="foreColor">
          <span class="prebartime">{{ hours }}:{{ minutes }}
            <div class="prebarssub-area">
                <span class="prebarampm">{{ ampm }}</span>
                <span class="pretimezone" :class="timezoneTextColor">{{ timezoneAbbreviation }}</span>
            </div>
          </span>
        </div>
      </div>
      <div class="set">
        <div class="country-timezone-select">
          <div class="country-select">
            <h3>国を選択</h3>
            <select v-model="selectedCountry" class="select-input">
              <option v-for="country in countries" :key="country.code" :value="country.code">{{ country.name }}</option>
            </select>
          </div>
          <div class="timezone-select">
            <h3>タイムゾーンを選択</h3>
            <select v-model="timezone" class="select-input">
              <option v-for="tz in filteredTimezones" :key="tz.value" :value="tz.value">{{ tz.label }}</option>
            </select>
          </div>
        </div>
        <h3>グラデーション選択</h3>
        <div class="gradient-grid">
          <label class="gradient-option" :class="{ active: color === 'green' }">
            <input type="radio" value="green" v-model="color" />
            <div class="gradient-preview green-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'sky' }">
            <input type="radio" value="sky" v-model="color" />
            <div class="gradient-preview sky-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'moon' }">
            <input type="radio" value="moon" v-model="color" />
            <div class="gradient-preview moon-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'lush' }">
            <input type="radio" value="lush" v-model="color" />
            <div class="gradient-preview lush-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'yellow' }">
            <input type="radio" value="yellow" v-model="color" />
            <div class="gradient-preview yellow-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'rose' }">
            <input type="radio" value="rose" v-model="color" />
            <div class="gradient-preview rose-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'blue' }">
            <input type="radio" value="blue" v-model="color" />
            <div class="gradient-preview blue-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'red' }">
            <input type="radio" value="red" v-model="color" />
            <div class="gradient-preview red-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'steel' }">
            <input type="radio" value="steel" v-model="color" />
            <div class="gradient-preview steel-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'gray' }">
            <input type="radio" value="gray" v-model="color" />
            <div class="gradient-preview gray-gradient-background"></div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'transparentwhite' }">
            <input type="radio" value="transparentwhite" v-model="color" />
            <div class="gradient-preview transparent-white-preview">透過(白)</div>
          </label>
          <label class="gradient-option" :class="{ active: color === 'transparent' }">
            <input type="radio" value="transparent" v-model="color" />
            <div class="gradient-preview transparent-preview">透過(黒)</div>
          </label>
        </div>
        <div class="purchase-section">
          <h3>プレミアム版について</h3>
          <p>このツールは有料のプレミアム版です。まずはBoothから商品を購入してください。</p>
          <a href="https://takatsukisyou.booth.pm/items/6188983" target="_blank" rel="noopener noreferrer" class="purchase-btn">
            <span>🛒 Boothで購入する</span>
          </a>
        </div>
        
        <h3>カスタマイズURL</h3>
        <div class="url-description">
          <p>各項目を選択するとコードが自動的に生成されます。</p>
          <p>購入後、同梱されているURLの末尾に下記コードを貼り付けます。</p>
        </div>
        <div class="url-container">
          <input :value="'?color=' + color + '&timezone=' + timezone" id="target" type="text" readonly class="url-input" />
          <button @click="copy" class="url-copy-btn">
            <span>コピー</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script scoped>
export default {
  name: "premiumBarClock",
  data() {
    return {
      hours: "",
      minutes: "",
      ampm: "",
      timezoneAbbreviation: "",
      color: 'green',
      selectedCountry: 'JP',
      timezone: 'Asia/Tokyo',
      countries: [
        {
          code: 'JP',
          name: '日本',
          timezones: [
            { label: '日本標準時 (JST)', value: 'Asia/Tokyo', abbreviation: 'JST' }
          ]
        },
        {
          code: 'CN',
          name: '中国',
          timezones: [
            { label: '中国標準時 (CST)', value: 'Asia/Shanghai', abbreviation: 'CST' }
          ]
        },
        {
          code: 'KR',
          name: '韓国',
          timezones: [
            { label: '韓国標準時 (KST)', value: 'Asia/Seoul', abbreviation: 'KST' }
          ]
        },
        {
          code: 'TW',
          name: '台湾',
          timezones: [
            { label: '台湾標準時 (CST)', value: 'Asia/Taipei', abbreviation: 'CST' }
          ]
        },
        {
          code: 'HK',
          name: '香港',
          timezones: [
            { label: '香港標準時 (HKT)', value: 'Asia/Hong_Kong', abbreviation: 'HKT' }
          ]
        },
        {
          code: 'ID',
          name: 'インドネシア',
          timezones: [
            { label: '西部インドネシア時間 (WIB)', value: 'Asia/Jakarta', abbreviation: 'WIB' },
            { label: '中央インドネシア時間 (WITA)', value: 'Asia/Makassar', abbreviation: 'WITA' },
            { label: '東部インドネシア時間 (WIT)', value: 'Asia/Jayapura', abbreviation: 'WIT' }
          ]
        },
        {
          code: 'TH',
          name: 'タイ',
          timezones: [
            { label: 'インドシナ時間 (ICT)', value: 'Asia/Bangkok', abbreviation: 'ICT' }
          ]
        },
        {
          code: 'US',
          name: 'アメリカ合衆国',
          timezones: [
            { label: '東部標準時 (EST)', value: 'America/New_York', abbreviation: 'EST' },
            { label: '中央標準時 (CST)', value: 'America/Chicago', abbreviation: 'CST' },
            { label: '山岳標準時 (MST)', value: 'America/Denver', abbreviation: 'MST' },
            { label: '太平洋標準時 (PST)', value: 'America/Los_Angeles', abbreviation: 'PST' }
          ]
        },
        {
          code: 'GB',
          name: 'イギリス',
          timezones: [
            { label: 'グリニッジ標準時 (GMT)', value: 'Europe/London', abbreviation: 'GMT' }
          ]
        },
        {
          code: 'BG',
          name: 'ブルガリア',
          timezones: [
            { label: '東ヨーロッパ時間 (EET)', value: 'Europe/Sofia', abbreviation: 'EET' }
          ]
        },
        {
          code: 'AU',
          name: 'オーストラリア',
          timezones: [
            { label: 'オーストラリア東部標準時 (AEST)', value: 'Australia/Sydney', abbreviation: 'AEST' },
            { label: 'オーストラリア中央標準時 (ACST)', value: 'Australia/Adelaide', abbreviation: 'ACST' },
            { label: 'オーストラリア西部標準時 (AWST)', value: 'Australia/Perth', abbreviation: 'AWST' }
          ]
        },
        // 必要に応じて他の国とタイムゾーンを追加してください
      ],
    };
  },

  computed: {
    foreColor() {
      const colorMap = {
        green: 'green-gradient-background',
        blue: 'blue-gradient-background',
        red: 'red-gradient-background',
        sky: 'sky-gradient-background',
        yellow: 'yellow-gradient-background',
        lush: 'lush-gradient-background',
        moon: 'moon-gradient-background',
        rose: 'rose-gradient-background',
        steel: 'steel-gradient-background',
        gray: 'gray-gradient-background',
        transparentwhite: 'transparent-white-background',
        transparent: 'transparent-background'
      };
      return colorMap[this.color] || '';
    },
    timezoneTextColor() {
      const textColorMap = {
        green: 'green-text-color',
        blue: 'blue-text-color',
        red: 'red-text-color',
        sky: 'sky-text-color',
        yellow: 'yellow-text-color',
        lush: 'lush-text-color',
        moon: 'moon-text-color',
        rose: 'rose-text-color',
        steel: 'steel-text-color',
        gray: 'gray-text-color',
        transparentwhite: 'transparent-text-color',
        transparent: 'transparent-text-color'
      };
      return textColorMap[this.color] || '';
    },
    filteredTimezones() {
      const country = this.countries.find(c => c.code === this.selectedCountry);
      return country ? country.timezones : [];
    }
  },
  watch: {
    selectedCountry(newCountry) {
      const country = this.countries.find(c => c.code === newCountry);
      if (country && country.timezones.length > 0) {
        this.timezone = country.timezones[0].value;
        this.timezoneAbbreviation = country.timezones[0].abbreviation;
      } else {
        this.timezone = '';
        this.timezoneAbbreviation = '';
      }
    },
    timezone(newTimezone) {
      const country = this.countries.find(c => c.code === this.selectedCountry);
      if (country) {
        const tz = country.timezones.find(t => t.value === newTimezone);
        this.timezoneAbbreviation = tz ? tz.abbreviation : '';
      }
    }
  },
  mounted() {
    this.updateTime();
    setInterval(this.updateTime, 1000);
    this.setInitialTimezoneAbbreviation();
  },
  methods: {
    setInitialTimezoneAbbreviation() {
      const country = this.countries.find(c => c.code === this.selectedCountry);
      if (country) {
        const tz = country.timezones.find(t => t.value === this.timezone);
        this.timezoneAbbreviation = tz ? tz.abbreviation : '';
      }
    },
    updateTime() {
      const now = new Date();
      const options = {
        timeZone: this.timezone,
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const parts = formatter.formatToParts(now);
      let hour, minute, dayPeriod;
      parts.forEach(part => {
        if (part.type === 'hour') hour = part.value;
        if (part.type === 'minute') minute = part.value;
        if (part.type === 'dayPeriod') dayPeriod = part.value.toLowerCase();
      });
      this.hours = this.zeroPadding(parseInt(hour), 2);
      this.minutes = this.zeroPadding(parseInt(minute), 2);
      this.ampm = dayPeriod === 'am' ? 'am' : 'pm';
    },
    zeroPadding(num, len) {
      return num.toString().padStart(len, '0');
    },
    copy() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText('?color=' + this.color + '&timezone=' + this.timezone);
        console.log('コピー完了');
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.clock-contents-block{
  text-align: left;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin: 24px auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}

#prebarclock {
  width: 220px;
  height: 70px;
  padding: 10px 28px 0px 28px;
  margin: 12px;
  border-radius: 2vh;
  color: #fff;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.prebartime {
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  font-size: 52px;
  margin-bottom: 8px;
}

.prebarssub-area{
  display: flex;
  flex-direction: column; /* 縦方向に配置 */
  line-height: 0.8;
  margin-left: 10px;
}

.prebarampm {
  font-size: 0.5em;
}

.pretimezone {
  font-size: 0.3em;
  margin-top: 2px;
  background-color: #fff;
  padding: 2px 4px;
  border-radius: 4px;
}

.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  align-self: flex-start;
  box-sizing: border-box;
  margin-left: 24px;
}

/* グラデーション選択グリッド */
.gradient-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 12px;
}

.gradient-option {
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  aspect-ratio: 2/1;
}

.gradient-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.gradient-option.active {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.3);
}

.gradient-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
}

.gradient-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.transparent-white-preview {
  background: #cfcfcf !important;
  color: #333 !important;
  text-shadow: none;
}

.transparent-preview {
  background: transparent !important;
  color: #333 !important;
  text-shadow: none;
  border: 1px solid #ccc;
}

.blue-gradient-background {
  background: linear-gradient(260deg,#FBDA61 0%, #FF5ACD 100%);
  background-size: 180% 180%;
  animation: blue-gradient-animation 10s ease infinite;
}

@keyframes blue-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.red-gradient-background {
  background: linear-gradient(43deg,#4158D0 0%, #C850C0 46%, #FFCC70 100%);
  background-size: 180% 180%;
  animation: red-gradient-animation 6s ease infinite;
}

@keyframes red-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.green-gradient-background {
  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

@keyframes green-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.sky-gradient-background {
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes sky-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.yellow-gradient-background {
  background: linear-gradient(260deg, #F3F9A7 0%, #CAC531 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.lush-gradient-background {
  background: linear-gradient(260deg, #56ab2f 0%, #a8e063 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.moon-gradient-background {
  background: linear-gradient(260deg, #4e54c8 0%, #8f94fb 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}
.rose-gradient-background {
  background: linear-gradient(260deg, #f4c4f3 0%, #fc67fa 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}
.steel-gradient-background {
  background: linear-gradient(260deg, #1F1C2C 0%, #928DAB 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}
.gray-gradient-background {
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

.barfont{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

/* URL生成セクション */
.url-description {
  margin-bottom: 16px;
}

.url-description p {
  margin-bottom: 8px;
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
}

.url-description a {
  color: #0f172a;
  text-decoration: underline;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.url-input {
  flex: 1;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #475569;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  outline: none;
  transition: all 0.2s ease;
}

.url-input:focus {
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.1);
  background: #ffffff;
}

.url-copy-btn {
  height: 40px;
  padding: 0 16px;
  background: #0f172a;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.url-copy-btn:hover {
  background: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.3);
}

.url-copy-btn:active {
  transform: translateY(0);
}

/* セレクト要素のスタイル */
.select-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: white;
  color: #1e293b;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  padding-right: 32px;
}

.select-input:focus {
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.1);
}

/* 購入セクション */
.purchase-section {
  margin: 24px 0;
}

.purchase-section h3 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
}

.purchase-section p {
  margin: 0 0 12px 0;
  color: #64748b;
  line-height: 1.5;
}

.purchase-btn {
  display: flex;
  color: #667eea;
  padding: 12px 0;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
}

.purchase-btn:hover {
  transform: translateY(-1px);
}

.purchase-btn span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.country-timezone-select {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.country-select, .timezone-select {
  display: flex;
  flex-direction: column;
}

/* 既存のselect-inputスタイルを使用 */

/* グラデーションに対応するフォントカラー */
.green-text-color {
  color: #80D0C7; /* グリーン */
}
.blue-text-color {
  color: #FF5ACD; /* ブルー */
}
.red-text-color {
  color: #C850C0; /* レッド */
}
.sky-text-color {
  color: #97D9E1; /* スカイ */
}
.yellow-text-color {
  color: #CAC531; /* イエロー */
}
.lush-text-color {
  color: #56ab2f; /* ラッシュ */
}
.moon-text-color {
  color: #4e54c8; /* ムーン */
}
.rose-text-color {
  color: #fc67fa; /* ローズ */
}
.steel-text-color {
  color: #928DAB; /* スティール */
}
.gray-text-color {
  color: #304352; /* グレー */
}

.transparent-background {
  background: transparent;
  color: #555!important;
  padding: 0 2px;
}

.transparent-text-color {
  color: #555;
  border: 1px solid #ccc;
}

.transparent-white-background {
  background: #cfcfcf;
  opacity: 0.5;
  border-radius: 0!important;
  color: #fff!important;
}
</style>